(function () {
  if (window.akEndless) return;

  function init(root = document) {
    if (!root) return;
    const elements = root.querySelectorAll ? Array.from(root.querySelectorAll('[data-ak-endless]')) : [];
    if (root.matches && root.matches('[data-ak-endless]') && !elements.includes(root)) {
      elements.unshift(root);
    }

    for (const scroller of elements) {
      if (scroller.hasAttribute('data-ak-ready')) continue;
      scroller.setAttribute('data-ak-ready', '');

      const rawNext = scroller.getAttribute('data-ak-next');
      let next = rawNext ? parseInt(rawNext, 10) : null;
      if (Number.isNaN(next)) next = null;
      const section = scroller.getAttribute('data-ak-section');

      let lastCard = null;
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            load();
            break;
          }
        }
      }, {
        root: scroller,
        rootMargin: '0px 150% 0px 150%'
      });

      function observeLast() {
        if (lastCard) {
          observer.unobserve(lastCard);
          lastCard = null;
        }
        const cards = Array.from(scroller.children).filter((child) => child.classList && child.classList.contains('t4s-col-item'));
        if (cards.length > 0) {
          lastCard = cards[cards.length - 1];
          observer.observe(lastCard);
        }
      }

      let loading = false;
      async function load() {
        if (loading || !next) return;
        loading = true;
        scroller.setAttribute('aria-busy', 'true');
        try {
          const rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const res = await fetch(`${rootUrl}?section_id=${encodeURIComponent(section)}&page=${next}`);
          if (!res.ok) throw new Error();
          const text = await res.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const incoming = doc.querySelector('[data-ak-endless]');
          if (!incoming) {
            next = null;
            return;
          }
          const newCards = Array.from(incoming.children).filter((child) => child.classList && child.classList.contains('t4s-col-item'));
          if (newCards.length === 0) {
            next = null;
            return;
          }
          for (const card of newCards) {
            scroller.appendChild(document.importNode(card, true));
          }
          const nextAttr = incoming.getAttribute('data-ak-next');
          const parsedNext = nextAttr ? parseInt(nextAttr, 10) : null;
          next = parsedNext && !Number.isNaN(parsedNext) ? parsedNext : null;
          observeLast();
        } catch (err) {
          next = null;
        } finally {
          loading = false;
          scroller.removeAttribute('aria-busy');
          updateArrows();
        }
      }

      observeLast();

      const wrap = scroller.closest('.ak-endless-wrap');
      const prevBtn = wrap ? wrap.querySelector('[data-ak-prev]') : null;
      const nextBtn = wrap ? wrap.querySelector('[data-ak-next-btn]') : null;

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const step = scroller.clientWidth * 0.9;
          const dir = getComputedStyle(scroller).direction === 'rtl' ? -1 : 1;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          scroller.scrollBy({ left: step * dir, behavior });
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          const step = scroller.clientWidth * 0.9;
          const dir = getComputedStyle(scroller).direction === 'rtl' ? -1 : 1;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          scroller.scrollBy({ left: -step * dir, behavior });
        });
      }

      function updateArrows() {
        const pos = Math.abs(scroller.scrollLeft);
        if (prevBtn) {
          prevBtn.hidden = pos < 4;
        }
        if (nextBtn) {
          nextBtn.hidden = (pos + scroller.clientWidth >= scroller.scrollWidth - 4) && (next === null);
        }
      }

      let ticking = false;
      scroller.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            updateArrows();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });

      updateArrows();
    }
  }

  window.akEndless = { init };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', () => init());
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
